import { language } from "../stores/languageStore";
import { dialogData, user } from "stores";
import { get } from "svelte/store";
import { storage } from "./storage";
import { Capacitor } from "@capacitor/core";
import initNativePushNotifications from "./initPushNotifications";
import { setupAvatars } from "./setupAvatars";
import { fetchNotifications } from "./fetchNotifications";
import { fetchUnreadAiActions } from "./fetchUnreadAiActions";
import { fetchChatSessions } from "./fetchSessions";
import { dialogTypes, serverlessRoutes, version } from "./constants";
import { putWithJwt } from "./requests";
import { fetchTags } from "./fetchTags";
import { isClient } from "./roles";
import { initSocketConnection } from "./initSocketConnection";
import { errorTracker } from "./errorTracker";
import {
  clearSharedTrainerChatState,
  fetchSharedAccountUsers,
  isSharedTrainerChatEnabled,
} from "./sharedTrainerChat";

const updateVersionInfo = async () => {
  const url = serverlessRoutes.PATCH_VERSION;
  try {
    await putWithJwt(url, { version });
  } catch (err) {}
};

const askForPhonenumber = async (user: any): Promise<void> => {
  let showPhonenumberDialog = await storage.get("showPhonenumberDialog");

  if (
    user &&
    isClient(user) &&
    (user.trainer.id === 13 || user.trainer.id === 87649) &&
    !user.phoneNumber &&
    showPhonenumberDialog !== false
  )
    dialogData.set({
      type: dialogTypes.ASK_FOR_PHONENUMBER,
      data: {},
      isCloseable: true,
      elem: undefined,
      component: undefined,
    });
};

export const initiateUser = async () => {
  const userRef = get(user);
  if (!userRef || !userRef.id) return;
  errorTracker.setUserId(userRef.id);
  language.set((await storage.get("language")) || "sr");

  if (isSharedTrainerChatEnabled(userRef)) {
    void fetchSharedAccountUsers();
  } else {
    clearSharedTrainerChatState();
  }

  if (Capacitor.isNativePlatform()) {
    initNativePushNotifications();
  }
  await askForPhonenumber(userRef);
  setupAvatars();
  fetchNotifications().then(() =>
    fetchChatSessions().then(async () => {
      await initSocketConnection();
    })
  );
  // Bell/AI-tab blue bubble count. Trainers only — clients never see the
  // AI Log surface — but the endpoint will safely return 0 for them too,
  // so no branching needed here.
  fetchUnreadAiActions();
  updateVersionInfo();
  fetchTags();
};
